import { Geofence } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface GeofenceInput {
  name: string;
  coordinates: string;
  max_speed?: number | null;
  actions?: {
    action_id?: number;
    vehicle_ids: number[];
    action: number;
    entry_exit: number;
    log?: string;
  }[];
}

export const geofenceService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<Geofence>>("/geofence", {
      params: {
        page: page,
        per_page: per_page,
        search: search,
        ...filters,
      },
    });
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/geofence/${id}`);
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<Geofence, false>>(
      `/geofence/${id}`,
    );
    return response.data;
  },

  async update(id: number | string, data: GeofenceInput) {
    const response = await api.put(`/geofence/${id}`, data);
    return response.data;
  },

  async create(data: GeofenceInput) {
    const response = await api.post("/geofence", data);
    return response.data;
  },
};
